/*
 * @Author: your name
 * @Date: 2021-08-10 00:38:33
 * @LastEditTime: 2022-03-08 23:44:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/api/index.js
 */
export const aggregationModule = ((r) => {
  const cache = {};

  r.keys().forEach((modulePath) => {
    const modules = r(modulePath);
    const moduleName = modulePath.match(/^\.\/(.+).js$/)[1];

    if (!cache[moduleName]) {
      cache[moduleName] = {};
    }

    Object.keys(modules).reduce((cacheModule, methodName) => {
      cacheModule[methodName] = modules[methodName];

      return cacheModule;
    }, cache[moduleName]);
  });
  return cache;
})(require.context("./modules/", false, /\.js$/));

export default function install(Vue) {
  Vue.prototype.$api = aggregationModule;
}
